// Component: locale-selectors — auto-submit localization form on change.
// Event delegation per Rule J2.

(function () {
  if (window.__localeSelectorHandlerBound) return;
  window.__localeSelectorHandlerBound = true;

  document.addEventListener('change', (e) => {
    const select = e.target.closest('[data-locale-selector]');
    if (!select) return;
    const form = select.closest('form');
    if (!form) return;
    form.submit();
  });
})();
